import { render, staticRenderFns } from "./PadoStatsComponent.vue?vue&type=template&id=2af68d58&scoped=true"
import script from "./PadoStatsComponent.vue?vue&type=script&lang=ts"
export * from "./PadoStatsComponent.vue?vue&type=script&lang=ts"
import style0 from "./PadoStatsComponent.vue?vue&type=style&index=0&id=2af68d58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af68d58",
  null
  
)

export default component.exports